import { render, staticRenderFns } from "./TablaAsignacion.vue?vue&type=template&id=08e876db"
import script from "./TablaAsignacion.vue?vue&type=script&lang=js"
export * from "./TablaAsignacion.vue?vue&type=script&lang=js"
import style0 from "./TablaAsignacion.vue?vue&type=style&index=0&id=08e876db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports